module.exports = __webpack_public_path__ + "static/xl-050185d3254eb7575eb45e75397f3e3a.jpg";